<template>
  <div>
     
 
    <div class="row bg grayBg" style="padding-bottom:60px;">
      <div class="col-md-10 offset-md-1">
        <h1 class="bd-title">
          <i class="fa fa-cog"></i> {{$t("mainTitle")}}
          <small class="text-muted">：</small>
        </h1>
        <p class="lead">
          {{$t("txtDescription")}}
        </p>
        <div class="row" style="margin-top:40px;">
          <div class="col-md-6" ref="imgCutterBox" style="height:458px;overflow:hidden;">
            <div v-if="params.isModal" style="width:100%;height:458px;background:#dedede;box-sizing:border-box;border:1px solid #dedede;">
              <div style="width:50%;margin:180px auto auto auto;">
                <div class="btn btn-primary btn-block" @click="pluginExe('handleOpen')">{{$t("cutLocalImage")}}</div>
                 
              </div>
            </div>
            <ImgCutter
              v-if="refresh"
              ref="imgCutterModal"
              :crossOrigin="params.crossOrigin"
              :label="params.label"
              :rate="params.rate"
              :isModal="params.isModal"
              :showChooseBtn="params.showChooseBtn"
              :lockScroll="params.lockScroll"
              :boxWidth="params.boxWidth"
              :boxHeight="params.boxHeight"
              :cutWidth="params.cutWidth"
              :cutHeight="params.cutHeight"
              :sizeChange="params.sizeChange"
              :moveAble="params.moveAble"
              :tool="params.tool"
              :DoNotDisplayCopyright="true"
              toolBgc="params.toolBgc"
              v-on:error="catchError"
              v-on:cutDown="cutDown">
              <span slot="open"></span>
              <span slot="choose" v-if="params.isModal==false"></span>
              <span slot="cancel" v-if="params.isModal==false"></span>
              <span slot="confirm" v-if="params.isModal==false"></span>
            </ImgCutter>
          </div>
          <div class="col-md-3">
            <div class="imgCutDownBox" :style="'height:458px;'">

              <div class="imgCutDownBoxContainer">
                <img :src="imgSrc" v-if="!!imgSrc" alt="">
                <span v-else class="imgCutDownTips">{{$t("showAfterProcess")}}</span>
              </div>

              <div class="text-center">
                <a :class="'btn btn-light'+ (imgSrc?'':' disabled')" :disabled="!imgSrc" :href="imgSrc" download="image.jpg" role="button">{{$t("downloadNewImage")}}</a>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <form>
               
              <div class="form-group">
                <div class="btn btn-primary btn-block" @click="pluginExe('chooseImg')">{{$t("cutLocalImage")}}</div>
              </div>
               
              <div class="form-group">
                <div class="btn btn-success btn-block" @click="pluginExe('cropPicture')">{{$t("submit")}}</div>
              </div>
              <div class="form-group">
                <div class="btn btn-light btn-block" @click="pluginExe('clearAll')">{{$t("reset")}}</div>
              </div>
            </form>
          </div>
        </div>
      </div>
  
    </div>
 
 
  </div>
</template>

<script>
  import config from '../package.json'
  import ImgCutter from './components/ImgCutter.vue'

  export default {
    name: 'App',
    components: {
      ImgCutter
    },
    data() {
      return {
        name: '',
        version: '',
        author: '',
        description: '',
        
        cutImgWidth: 300,
        cutImgHeight: 300,
        imgSrc: null,
        refresh: true,
        isForIe9: false,
        params: {
          crossOrigin: true,
          crossOriginHeader: '*',
          rate: '',
          toolBgc: 'none',
          isModal: false,
          showChooseBtn: true,
          lockScroll: true,
          boxWidth: 500,
          boxHeight: 458,
          cutWidth: 250,
          cutHeight: 250,
          sizeChange: true,
          moveAble: true,
          tool: true,
        },
  
      }
    },
    created() {
      this.name = config.name;
      this.version = config.version;
      this.author = config.author;
      this.description = config.description;
 
    },
    mounted() {
      let $imgCutterBox = this.$refs.imgCutterBox;
      this.params.boxWidth = $imgCutterBox.offsetWidth-30;
    //  this.forIe9();
    },
    methods: {
      cutDown: function (res) {
        console.log(res);
        this.imgSrc = res.dataURL;
      },
      forIe9: function () {
        this.$refs.imgCutterModal.handleOpen({
          name: this.cutImgSrc,
          src: this.cutImgSrc,
          width: this.cutImgWidth,
          height: this.cutImgHeight,
        });
      },
      doRefresh: function () {
        this.refresh = false;
        this.$nextTick(() => {
          this.refresh = true;
        })
      },
 
      setData: function ($event) {
        function isNumber(val) {
          let regPos = /^\d+(\.\d+)?$/; //非负浮点数
          let regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/; //负浮点数
          if (regPos.test(val) || regNeg.test(val)) {
            return true;
          } else {
            return false;
          }
        }

        let value = $event.target.value;
        if (value === 'true') {
          value = true
        }
        if (value === 'false') {
          value = false
        }
        if (isNumber(value) === true) {
          value = parseInt(value);
        }
        this.params[$event.target.name] = value;
        this.doRefresh();
 
      },
      catchInput(e) {
        let val = e.target.value;
        let key = e.target.name;
        this[key] = val;
      },
      catchError(res) {
        console.log(res);
        window.alert(res.msg);
      },
      pluginExe:function(functionName){
        this.$refs.imgCutterModal[functionName]();
      },
    }
  }
</script>
<style scoped>
  .bg {
    padding-top: 50px;
  }

  .grayBg {
    background: #f1f5f7;
  }
  .imgCutDownBox {
    width:100%;
    background:#dedede;
    box-sizing:border-box;
    border:1px solid #dedede;
  }
  .imgCutDownBoxContainer {
    width:90%;
    height:360px;
    overflow:hidden;
    margin:20px auto;
    border:1px solid #ccc;
    background:#fff;
    text-align:center;
  }
  .imgCutDownBoxContainer img {
    max-width:100%;
    max-height:100%;
    margin-top:50%;
    transform: translateY(-50%);
  }
  .imgCutDownTips {
    font-size:0.8em;
    line-height:360px;
    color:#c0c4cc;
  }
  .alipay {
    width:200px;
    padding:10px;
    border-radius: 3px;
    border:1px solid #333;
    display:inline-block;
    margin-right:30px;
  }
  .alipay img {
    width:100%;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue